import { Link } from "react-router-dom";
import VerdictBadge from "@/components/base/VerdictBadge";
import { getFeaturedCase } from "@/mocks/cases";

const stats = [
  { value: "1,286", label: "累计核验事件" },
  { value: "327", label: "反转案例归档" },
  { value: "94%", label: "结论附公开来源" },
];

export default function Hero() {
  const featured = getFeaturedCase();

  return (
    <section className="relative w-full overflow-hidden bg-background-100">
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-accent-100 opacity-60 blur-3xl" aria-hidden="true" />
      <div className="pointer-events-none absolute -right-20 bottom-0 h-72 w-72 rounded-full bg-primary-100 opacity-50 blur-3xl" aria-hidden="true" />

      <div className="relative mx-auto grid w-full max-w-[1240px] grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50 px-3 py-1.5 text-xs font-semibold text-primary-700">
            <span className="flex h-3.5 w-3.5 items-center justify-center" aria-hidden="true">
              <i className="ri-focus-3-line text-sm" />
            </span>
            真相核验 · 一站直达
          </span>

          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
            看清一条爆料，
            <br className="hidden sm:block" />
            需要
            <span className="relative inline-block px-1">
              <span className="absolute inset-x-0 bottom-1 z-0 h-1.5 rounded-full bg-accent-300/70" aria-hidden="true" />
              <span className="relative z-10 text-primary-600">几个角度</span>
            </span>
            ？
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
            棱镜求证把散落在各平台的社会爆料、反转进展、官方回应与辟谣结论，按同一起事件重新聚合。
            用一条清晰的时间线，帮你在转发之前先看清全貌。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/cases"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
            >
              <i className="ri-stack-line text-base" aria-hidden="true" />
              <span className="whitespace-nowrap">浏览事件案例库</span>
            </Link>
            <Link
              to="/guide"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-accent-400 hover:text-accent-800"
            >
              <i className="ri-book-open-line text-base" aria-hidden="true" />
              <span className="whitespace-nowrap">学会自己求证</span>
            </Link>
          </div>

          <dl className="mt-9 grid max-w-lg grid-cols-3 gap-4 border-t border-background-300 pt-6">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="sr-only">{item.label}</dt>
                <dd className="font-label text-2xl font-semibold text-foreground-950 md:text-3xl">
                  {item.value}
                </dd>
                <p className="mt-1 text-xs text-foreground-500 md:text-sm">{item.label}</p>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-5">
          <div className="relative mx-auto max-w-md lg:max-w-none">
            <div className="w-full overflow-hidden rounded-lg border border-background-300 bg-background-50">
              <div className="h-64 w-full bg-background-200 md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20conceptual%20photograph%20of%20a%20glass%20prism%20splitting%20a%20single%20warm%20light%20beam%20into%20deep%20vermilion%20and%20amber%20tones%20against%20a%20dark%20charcoal%20background%2C%20dramatic%20studio%20lighting%2C%20minimal%20geometric%20editorial%20composition%2C%20high%20detail%2C%20cinematic%20mood%2C%20no%20text&width=900&height=1100&seq=hero-prism-01&orientation=portrait"
                  alt="棱镜将一束光分成多个角度，象征从多角度核验社会爆料"
                  title="棱镜求证 · 多角度核验社会爆料真相"
                  className="h-full w-full object-cover object-top"
                />
              </div>

              <div className="border-t border-background-200 p-5">
                <div className="flex items-center justify-between gap-3">
                  <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-primary-600">
                    <i className="ri-flashlight-line text-sm" aria-hidden="true" />
                    本周反转案例
                  </span>
                  <VerdictBadge verdict={featured.status} />
                </div>
                <h2 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  <Link to={`/cases/${featured.slug}`} className="transition-colors hover:text-primary-700">
                    {featured.title}
                  </Link>
                </h2>
                <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-map-pin-line text-sm" aria-hidden="true" />
                    {featured.region}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-fire-line text-sm" aria-hidden="true" />
                    热度 {featured.heat.toLocaleString()}
                  </span>
                </div>
              </div>
            </div>

            <div className="absolute -bottom-4 -left-4 hidden items-center gap-2 rounded-md border border-background-200 bg-background-50 px-3.5 py-2.5 md:flex">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-800" aria-hidden="true">
                <i className="ri-file-shield-2-line text-base" />
              </span>
              <span className="text-xs leading-tight text-foreground-700">
                每条结论
                <br />
                均附公开来源
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}